import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import ApiTerms from '../components/terms/api_body';

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Api", "terms/api_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Api || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <ApiTerms />
    </div>
  );
};

export default Page;